import { ReportTotalItem } from '@/constants/ReportDashboard/report-items'
import { useContext, useMemo } from 'react'
import { RADashboardDataContext } from '.'

export function useDataContext() {
  const context = useContext(RADashboardDataContext);
  return context;
}

export function usePortfolioMarketValue() {
  const context = useDataContext();
  return context.marketValue;
}

export function usePortfolioBaseCCY() {
  const context = useDataContext();
  return context.baseCurrency;
}

export function useVaRParameters() {
  const context = useDataContext();
  return context.varInfo;
}

export function useCovarianceMatrix() {
  const context = useDataContext();
  return context.covarianceMatrix;
}

export function useRiskModel() {
  const context = useDataContext();
  return context.riskModel;
}

export function useDataStore() {
  const context = useContext(RADashboardDataContext);
  return context.dataStore;
}

export function useIsAnalysisLoading() {
  const context = useDataContext();
  return context.loading;
}

export function useReportId() {
  const store = useDataStore();
  return store?.reportId ?? null;
}

export function useFactorLens() {
  const store = useDataStore();
  return store?.factorLens ?? null;
}

export function useRiskOneYearHistory() {
  const store = useDataStore();
  return store?.riskOneYearHistory ?? null;
}

export function useHoldingsSecurityDetails() {
  const store = useDataStore();
  return store?.holdingsSecurityDetails ?? null;
}

export function useTopBottomContribs(count: number = 5) {
  const store = useDataStore();
  const endContribResult = store?.endContribPortfolio || null;
  const contribResult = useMemo(() => {
    if (endContribResult == null) return null;
    const { endCount, topContribs, botContribs } = endContribResult;
    const retCount = Math.max(0, Math.min(endCount, count));
    const result = {
      top: topContribs.slice(0, retCount),
      bottom: botContribs.slice(endCount - retCount)
    };
    return result;
  }, [endContribResult, count]);
  return contribResult;
}

export function useRiskMetricsSummary() {
  const store = useDataStore();
  return store?.riskMetricsSummary ?? null;
}

export function usePortfolioReportTotalItem(item: ReportTotalItem) {
  const store = useDataStore();
  return store?.portfolioReportItems[item] ?? null;
}
